// extracted by mini-css-extract-plugin
export default {"container":"Mailfail_Details_container__185RS"};